import { apiSlice } from "../../../api/ApiService";
import { getHeadersFromRedux } from "../../../utility/functions/common-functions";

const faqApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getFaq: builder.query({
      query: ({
        faqFilterQuery,
        preferredLanguage,
      }: {
        faqFilterQuery: string;
        preferredLanguage: string;
      }) => {
        const headers = getHeadersFromRedux();
        headers["X-Language"] = preferredLanguage;
        return {
          url: `/api/v1/Patient/faq/${faqFilterQuery}`,
          method: "GET",
          headers,
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetFaqQuery } = faqApi;
export default faqApi;
